<template>
  <div class="experimentation">
    <Home v-if="$route.path === '/experimentation'" />
    <div v-else>
      <Exper-header
        v-show="$route.path !== '/experimentation/experimentation3'"
        :title="titleText"
      />
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import ExperHeader from '@/components/experimentation/exper-header.vue'
import Home from './exp-home.vue'
import { mapState } from 'vuex'
export default {
  name: 'experimentation',
  components: { ExperHeader, Home },
  props: [],
  data() {
    return {
      titles_path: '',
      titles: [
        {
          path: '/experimentation/test',
          img: this.publicData.serverUrl + 'images/title_test.png',
          title: '考核测试',
        },
        {
          path: '/experimentation/report',
          img: this.publicData.serverUrl + 'images/repore@2x.png',
          title: '实验报告',
        },
        {
          path: '/experimentation/experimentation1/2',
          img: this.publicData.serverUrl + 'images/exp1_title2.png',
          title: '天后宫空间布局',
        },
        {
          path: '/experimentation/experimentation1',
          img: this.publicData.serverUrl + 'images/mother_title@2x.png',
          title: '妈祖信仰与泉州天后宫',
        },
        {
          path: '/experimentation/experimentation1/1',
          img: this.publicData.serverUrl + 'images/mother_title@2x.png',
          title: '妈祖信仰海外传播',
        },
        {
          path: '/experimentation/experimentation2',
          img: this.publicData.serverUrl + 'images/exp2_title.png',
          title: '传统建筑设计与构造教学',
        },
        {
          path: '/experimentation/experimentation2/1',
          img: this.publicData.serverUrl + 'images/exp2_title_1.png',
          title: '闽南侨乡传统建筑构造',
        },
        {
          path: '/experimentation/experimentation2/2',
          img: this.publicData.serverUrl + 'images/exp2_title_2.png',
          title: '各部位做法工序',
        },
        {
          path: '/experimentation/experimentation2/2/1',
          img: this.publicData.serverUrl + 'images/roof.png',
          title: '传统屋面',
        },
        {
          path: '/experimentation/experimentation2/2/2',
          img: this.publicData.serverUrl + 'images/frame.png',
          title: '传统木架构',
        },
        {
          path: '/experimentation/experimentation2/2/3',
          img: this.publicData.serverUrl + 'images/wall.png',
          title: '传统墙体',
        },
        {
          path: '/experimentation/experimentation2/2/4',
          img: this.publicData.serverUrl + 'images/ground.png',
          title: '传统地面',
        },
        {
          path: '/experimentation/experimentation3',
          img: this.publicData.serverUrl + 'images/exp2_title_3.png',
          title: '闽南侨乡传统建筑修缮训练',
        },
      ],
      titlePath: '',
    }
  },
  watch: {
    $route() {
      this.setTitle()
    },
  },
  computed: {
    ...mapState(['translate_imgs']),
    titleText() {
      let text = ''
      this.titles.forEach((v) => {
        if (this.$route.path === v.path) text = v.title
      })
      return text
    },
  },
  created() {
    this.setTitle()
  },
  mounted() {},
  methods: {
    // setTitle() {
    //   this.titles.forEach((v) => {
    //     if (this.$route.path === v.path) this.titlePath = v.img
    //   })
    // },
    setTitle() {
      this.titles.forEach((v) => {
        if (this.$route.path === v.path) {
          this.titles_path = v.path
          this.titlePath = v.img
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.experimentation {
  width: 100%;
  min-height: 100vh;
  background-image: var(--exp_bg);
  background-size: 100% 100%;
}
</style>